// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__2RNKG","layout-body":"style_layout-body__HSXQk"};